// Form actions
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS'
export const CLEAR_FORM_ERRORS = 'CLEAR_FORM_ERRORS'
export const RESET_SERVER_ERRORS = 'RESET_SERVER_ERRORS'

// Set form validation errors from API response
export const setFormErrors = (errors) => {
  return {
    type: SET_FORM_ERRORS,
    payload: errors
  }
}

// Clear form errors
export const clearFormErrors = () => {
  return {
    type: CLEAR_FORM_ERRORS
  }
}

// Reset server errors
export const resetServerErrors = () => {
  return {
    type: RESET_SERVER_ERRORS
  }
}
